import { render, staticRenderFns } from "./AppSettingOtherList.vue?vue&type=template&id=d8188bbe&scoped=true&"
import script from "./AppSettingOtherList.vue?vue&type=script&lang=js&"
export * from "./AppSettingOtherList.vue?vue&type=script&lang=js&"
import style0 from "./AppSettingOtherList.vue?vue&type=style&index=0&id=d8188bbe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8188bbe",
  null
  
)

export default component.exports